export default __webpack_public_path__ + "static/media/tick-black.8a810d13.svg";